import script from "./BaseArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseArrow.vue?vue&type=script&setup=true&lang=js"

import "./BaseArrow.vue?vue&type=style&index=0&id=4e9cc84d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9cc84d"]])

export default __exports__